import React from "react";
import { useParams } from "react-router-dom";

const TabbedCardFile = () => {
  const { id } = useParams();

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Card File Details</h1>
      <div className="bg-white shadow-md rounded-md p-6">
        <p className="text-gray-500">Viewing card file with ID: {id || "unknown"}</p>
        <p className="text-gray-500 mt-4">This is a placeholder component.</p>
      </div>
    </div>
  );
};

export default TabbedCardFile;
